import { render, staticRenderFns } from "./Qualifications.vue?vue&type=template&id=6b71718e&scoped=true&"
import script from "./Qualifications.vue?vue&type=script&lang=js&"
export * from "./Qualifications.vue?vue&type=script&lang=js&"
import style0 from "./Qualifications.vue?vue&type=style&index=0&id=6b71718e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b71718e",
  null
  
)

export default component.exports